<template>
  <div>    
    <base-title :title="StringLanguage.deliveryTimes" :subtitle="StringLanguage.configurations" :link="'configuracoes'"/>

    <base-box>
      <base-label :text="StringLanguage.delivery" />
      <base-input :label="StringLanguage.minDeliveryTime" v-model="times.minDelivery" :moneyMask="StringLanguage.timeConfigs.minutes" :masked="false" class="mt_20" :valid="userError !== 'minDelivery'" @focus="clearError('minDelivery')" />
      <base-input :label="StringLanguage.maxDeliveryTime" v-model="times.maxDelivery" :moneyMask="StringLanguage.timeConfigs.minutes" :masked="false" class="m_0" :valid="userError !== 'maxDelivery'" @focus="clearError('maxDelivery')" />
    </base-box>
    <base-box>
      <base-label :text="StringLanguage.withdrawAtCounter"/>
      <div v-if="!keys.hideOnlineLocation">
        <base-input :label="StringLanguage.minWithdrawAtCounterTime" v-model="times.minDesk" :disabled="keys.hideOnlineLocation" :moneyMask="StringLanguage.timeConfigs.minutes" :masked="false" class="mt_20" :valid="userError !== 'minDesk'" @focus="clearError('minDesk')" />
        <base-input :label="StringLanguage.maxWithdrawAtCounterTime" v-model="times.maxDesk" :disabled="keys.hideOnlineLocation" :moneyMask="StringLanguage.timeConfigs.minutes" :masked="false" class="m_0" :valid="userError !== 'maxDesk'" @focus="clearError('maxDesk')" />
      </div>
      <base-checkbox label="Ocultar retirada no balcão" v-model="keys.hideOnlineLocation" :checked="keys.hideOnlineLocation" class="mt_30 mb_5"/>
    </base-box>
    
    <!-- <div class="d-flex justify-end w-100">
      <base-button :text="StringLanguage.save" @click="save()" :disabled="loadingData" />
    </div> -->
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import DeliveryTime from "@/plugins/core/schema/configurations/DeliveryTime/DeliveryTime"
import StoreAPI from '@/api/store'
import Vue from 'vue'

import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseInput from '@/components/Input'
import BaseLabel from '@/components/Label'
import BaseCheckbox from '@/components/Checkbox'

export default {
  data() {
    return { 
      originalData: {
        delivery_time: null,
        keys: { hideOnlineLocation: false },
      },
      loadingData: false,
      times: new DeliveryTime(), 
      keys: { hideOnlineLocation: false },
      userError: null
    }
  },
  beforeRouteLeave (to, from, next) {
    if(
      JSON.stringify(this.originalData.delivery_time) != JSON.stringify(this.times) ||
      JSON.stringify(this.originalData.keys) != JSON.stringify(this.keys)
    ) {
      if(this.validateTimes()){
        return this.save().then(() => { 
            next(); 
        });
      }
    }else{
      next();
    } 
  },
  created() {
    let self = this;
    this.loadingData = true;
    StoreAPI.storeGetConfiguration().then((response) => {
      self.set(response);
    }).catch((err) => {
      console.log(err);
      alert(StringLanguage.loadError)
    }).finally(() => { 
      this.loadingData = false; 
    })
  },
  methods: {
    set(response) {
      if(response.getErrors([]).length > 0) {
        return false
      } else if(response.getData({}).delivery_time || false) {
        let times = response.getData(new DeliveryTime).delivery_time;
        Vue.set(this, 'times', new DeliveryTime( times.minDelivery, times.maxDelivery,  times.minDesk,  times.maxDesk ));
        this.setOriginal('delivery_time', new DeliveryTime( times.minDelivery,  times.maxDelivery,  times.minDesk,  times.maxDesk ));

        let keys = response.getData({}).keys;
        if (keys) {
          keys.hideOnlineLocation = keys.hideOnlineLocation ? keys.hideOnlineLocation : false
          Vue.set(this, 'keys', keys);
          this.setOriginal('keys', keys);
        }
      } else {
        Vue.set(this, 'times', new DeliveryTime(0, 0, 0, 0));
        this.setOriginal('delivery_time', new DeliveryTime(0, 0, 0, 0));
      }

      
    },
    setOriginal(key, value) {
      Vue.set(this.originalData, key, JSON.parse(JSON.stringify(value || null)));
    },
    validateTimes(){
      const times = this.times;
      const keys = this.keys;

      if (
        this.validTime(times.minDelivery, 'minDelivery') ||
        this.validTime(times.maxDelivery, 'maxDelivery') ||
        this.validTime(times.minDesk, 'minDesk', keys.hideOnlineLocation) ||
        this.validTime(times.maxDesk, 'maxDesk', keys.hideOnlineLocation)
      ) {
        alert(StringLanguage.errorTimeInvalid);
        return false;
      }

      if((+times.maxDelivery) <= (+times.minDelivery)){
        this.userError = 'maxDelivery';
        alert(StringLanguage.errorMaxMinDeliveryTime);
        return false;
      }else if(!keys.hideOnlineLocation && (+times.maxDesk) <= (+times.minDesk)){
        this.userError = 'maxDesk';
        alert(StringLanguage.errorMaxMinWithdrawAtCounterTime);
        return false;
      }

      return true;
    },
    clearError(prop) {
      if (this.userError === prop)
        this.userError = null;
    },
    validTime(value, prop, ignoreValidation = false) {
      if (ignoreValidation) return false;
      
      if ((+value) <= 0) {
        this.userError = prop;
        return true;
      }
    },
    save() {
      let self = this;
      return StoreAPI.storeConfiguration({
        'delivery_time': this.times,
        'keys': this.keys
      }).then((response) => {
        self.set(response)
        this.$store.dispatch('store/getConfigurations')
      }).catch((err) => {
        console.log(err);
        alert(StringLanguage.saveError)
      }).finally(() => { 
        this.loadingData = false; 
      })
    }
  },
  components: {
    TheMask,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseCheckbox
  }
}
</script>